import { GraphPayload, GraphQueryInput, createQuery } from '@ta/server';
import { userInfo } from '@ta/user';

import { TenantApplication } from '../tenant-applications/dto/tenant-application';
import { IdentityVerification, identityVerificationProps } from './dto/identity-verification';

export function myIdentityVerificationQuery(): GraphPayload {
  return createQuery<IdentityVerification>('myIdentityVerification', {
    props: `
      ${identityVerificationProps.get('id')}
      ${identityVerificationProps.get('status')}
    `,
  });
}

export function tenantApplicationsByTenant(
  input: GraphQueryInput<TenantApplication>,
): GraphPayload {
  return createQuery<TenantApplication>('tenantApplicationsByTenant', {
    ...input,
    prefixType: 'TenantApplication',
  });
}

export function userInfoQuery(input: { props: string }): GraphPayload {
  return { ...userInfo(input), name: 'userInfo' };
}
